import React, { useEffect, useState } from "react";
import { Input, Table, Row, Col, DatePicker, Card, Form, Button } from "antd";
import { fetchData,showError, toLocalDateTime } from "../../../utils";
import moment from "moment";

const CompletedOrdersTab = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState({
        dateFrom: null,
        dateTo: null,
        orderId: "",
        status: "",
    });

    useEffect(() => {
        getFilterData();
    }, [filterData]);

    const handleSearch = () => {
        if (filterData.dateFrom && filterData.dateTo && moment(filterData.dateFrom).isAfter(filterData.dateTo)) {
            showError("Start date cannot be after end date");
            return;
        }
        getFilterData();
    };

    const getFilterData = () => {
        setLoading(true);
        const queryParams = new URLSearchParams();
        if (filterData.dateFrom) queryParams.append("dateFrom", filterData.dateFrom);
        if (filterData.dateTo) queryParams.append("dateTo", filterData.dateTo);
        if (filterData.orderId) queryParams.append("orderIds", filterData.orderId);
        if (filterData.status) queryParams.append("status", filterData.status);

        fetchData(`${window.SiteBasePath}/api/OrdersAutomation/SearchOrders?${queryParams.toString()}`)
            .then((resp) => {
                setOrders(resp);
            })
            .catch((error) => {
                console.error("Error fetching orders:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const itemColumns = [
        {
            title: "SKU",
            dataIndex: "SKU",
            key: "SKU",
            width: 150,
        },
        {
            title: "Product Name",
            dataIndex: "ProductName",
            key: "ProductName",
            width: 200,
        },
        {
            title: "Quantity",
            dataIndex: "QuantityPurchased",
            key: "QuantityPurchased",
            width: 150,
        },
        {
            title: "Price",
            dataIndex: "ItemPrice",
            key: "ItemPrice",
            width: 150,
        },
        {
            title: "Tax",
            dataIndex: "ItemTax",
            key: "ItemTax",
            width: 150,
        },
    ];

    const columns = [
        {
            title: "Order ID",
            dataIndex: "OrderId",
            key: "OrderId",
            width: 'auto',
        },
        {
            title: "Purchase Date",
            dataIndex: "PurchaseDate",
            key: "PurchaseDate",
            width: 'auto',
            render: (date) => date ? toLocalDateTime(date, "YYYY-MM-DD HH:mm:ss") : "",
        },
        {
            title: "Buyer Email",
            dataIndex: "BuyerEmail",
            key: "BuyerEmail",
            width: 150,
        },
        {
            title: "Buyer Name",
            dataIndex: "BuyerName",
            key: "BuyerName",
            width: 150,
        },
        {
            title: "Buyer Phone Number",
            dataIndex: "BuyerPhoneNumber",
            key: "BuyerPhoneNumber",
            width: 150,
        },
        {
            title: "Tracking ID",
            dataIndex: "TrackingId",
            key: "TrackingId",
            width: 150,
        },
        {
            title: "Supplier Order Id",
            dataIndex: "SupplierOrderId",
            key: "SupplierOrderId",
            width: 150,
        },
        {
            title: "Supplier",
            dataIndex: "Supplier",
            key: "Supplier",
            width: 150,
        },
        {
            title: "Currency",
            dataIndex: "Currency",
            key: "Currency",
            width: 100,
        },
        {
            title: "Shipping Price",
            dataIndex: "ShippingPrice",
            key: "ShippingPrice",
            width: 150,
        },
        {
            title: "Shipping Tax",
            dataIndex: "ShippingTax",
            key: "ShippingTax",
            width: 150,
        },
        {
            title: "Ship Service Level",
            dataIndex: "ShipServiceLevel",
            key: "ShipServiceLevel",
            width: 200,
        },
        {
            title: "Recipient Name",
            dataIndex: "RecipientName",
            key: "RecipientName",
            width: 200,
        },
        {
            title: "Ship Address 1",
            dataIndex: "ShipAddress1",
            key: "ShipAddress1",
            width: 200,
        },
        {
            title: "Ship Address 2",
            dataIndex: "ShipAddress2",
            key: "ShipAddress2",
            width: 200,
        },
        {
            title: "Ship Address 3",
            dataIndex: "ShipAddress3",
            key: "ShipAddress3",
            width: 200,
        },
        {
            title: "Address Type",
            dataIndex: "AddressType",
            key: "AddressType",
            width: 150,
        },
        {
            title: "Ship City",
            dataIndex: "ShipCity",
            key: "ShipCity",
            width: 150,
        },
        {
            title: "Ship State",
            dataIndex: "ShipState",
            key: "ShipState",
            width: 150,
        },
        {
            title: "Ship Postal Code",
            dataIndex: "ShipPostalCode",
            key: "ShipPostalCode",
            width: 150,
        },
        {
            title: "Ship Country",
            dataIndex: "ShipCountry",
            key: "ShipCountry",
            width: 150,
        },
        {
            title: "Ship Phone Number",
            dataIndex: "ShipPhoneNumber",
            key: "ShipPhoneNumber",
            width: 150,
        },
        {
            title: "Is Buyer Requested Cancellation",
            dataIndex: "IsBuyerRequestedCancellation",
            key: "IsBuyerRequestedCancellation",
            width: 150,
        },
        {
            title: "Buyer Requested Cancel Reason",
            dataIndex: "BuyerRequestedCancelReason",
            key: "BuyerRequestedCancelReason",
            width: 150,
        },
        {
            title: "Order Status",
            dataIndex: "OrderStatus",
            key: "OrderStatus",
            width: 150,
        },
    ];

    return (
        <Card title="Completed Orders" style={{ height: "100%" }}>
            <Form layout="vertical">
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="Start Date">
                            <DatePicker
                                style={{ width: "100%" }}
                                value={filterData.dateFrom ? moment(filterData.dateFrom) : ""}
                                onChange={(date) => {
                                    setFilterData({
                                        ...filterData,
                                        dateFrom: date ? date.format("YYYY-MM-DD") : "",
                                    });
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="End Date">
                            <DatePicker
                                style={{ width: "100%" }}
                                value={filterData.dateTo ? moment(filterData.dateTo) : ""}
                                onChange={(date) => {
                                    setFilterData({
                                        ...filterData,
                                        dateTo: date ? date.format("YYYY-MM-DD") : "",
                                    });
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Order ID">
                            <Input

                                value={filterData.orderId}
                                onChange={(e) => {
                                    setFilterData({
                                        ...filterData,
                                        orderId: e.target.value,
                                    });
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                marginBottom: 0
                            }}
                        >
                            <Button
                               
                                onClick={handleSearch}
                            >
                                Refresh
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Table
                columns={columns}
                dataSource={orders}
                rowKey="OrderId"
                loading={loading}
                scroll={{ x: "max-content", y: "calc(100vh - 200px)" }}
                expandable={{
                    expandedRowRender: (record) => (
                        <Table
                            columns={itemColumns}
                            dataSource={record.Items}
                            rowKey="SKU"
                            pagination={false}
                            scroll={{ x: "100%" }}
                        />
                    ),
                    rowExpandable: (record) => record.Items && record.Items.length > 0,
                }}
            />
        </Card>
    );
};

export default CompletedOrdersTab;